import { Dispatch, SetStateAction } from 'react';
import { TSectionAnchor, INavLinks, sectionsMapper } from '../../settings';
import { setHash } from '../../utils';

export function getDOMSections(): NodeListOf<HTMLElement> {
  return document.querySelectorAll('section[id]');
}

export function getNavLinksFromSections(sections: NodeListOf<HTMLElement>): INavLinks[] {
  if (sections.length < 1) {
    return [];
  }

  return Array.from(sections).map(section => {
    const id = section.getAttribute('id') || '';

    return {
      value: id as TSectionAnchor,
      title: sectionsMapper[id],
      offsetTop: section.offsetTop,
      offsetHeight: section.offsetHeight,
    };
  });
}

export function updateActiveSection(sections: INavLinks[], onActiveSection: Dispatch<SetStateAction<TSectionAnchor>>) {
  if (sections.length < 1) {
    return;
  }

  const scrollY = window.pageYOffset;

  sections.forEach(section => {
    const sectionTop = section.offsetTop - 100;

    if (section.value && scrollY > sectionTop && scrollY <= sectionTop + section.offsetHeight) {
      onActiveSection(section.value as TSectionAnchor);
      setHash(section.value);
    }
  });
}
